import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const GenerateOR = createAsyncThunk(
    "qr/generate-qr",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.WhatsApp.Generate, data);
            return res;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const getUserQr = createAsyncThunk(
    "qr/getUser-qr",
    async (_, { rejectWithValue }) => {

        try {
            const res = await GET(`${APIS.WhatsApp.Generate}`);
            return res;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getUserCred = createAsyncThunk(
    "qr/getUser-cred",
    async (_, { rejectWithValue }) => {

        try {
            const res = await GET(`${APIS.WhatsApp.CRED}`);
            return res;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateWebhook = createAsyncThunk(
    "qr/updateWebhook-qr",
    async (data, { rejectWithValue }) => {

        try {
            const res = await PUT(APIS.WhatsApp.updateWebhook, data);
            return res;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const resetInstance = createAsyncThunk(
    "qr/resetInstance",
    async (_, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.WhatsApp.ResetWhatsApp);

            return res;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const deleteInstance = createAsyncThunk(
    "qr/deleteInstance",
    async (_, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.WhatsApp.DeleteWhatsApp);
            return res;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const LogOut = createAsyncThunk(
    "qr/LogOut-qr",
    async (data, { rejectWithValue }) => {

        try {
            const res = await POST(APIS.WhatsApp.LogOutWhatsApp, data);

            return res;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);


export const Slice = createSlice({
    name: "qr",
    initialState: {
        qr: null,
        data: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingle, GenerateOR, Update, Delete
            .addCase(GenerateOR.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GenerateOR.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;

                state.qr = action.payload.data;
            })
            .addCase(GenerateOR.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(getUserQr.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(getUserQr.fulfilled, (state, action) => {
                state.data = action.payload?.data || [];
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(getUserQr.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
